import { render } from "./cSidebar.vue?vue&type=template&id=4cb4a45a&scoped=true"
import script from "./cSidebar.vue?vue&type=script&lang=js"
export * from "./cSidebar.vue?vue&type=script&lang=js"

import "./cSidebar.vue?vue&type=style&index=0&id=4cb4a45a&scoped=true&lang=css"

import exportComponent from "C:\\DevOps\\EPS\\Internal\\Clockwork\\ClockWork.Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb4a45a"]])

export default __exports__